// Tiny Slider owns its deferred images; do not eagerly fetch its hidden slides.
const images = document.querySelectorAll('[data-src]:not(.tns-lazy-img)')
const loadImages = () => {
    images.forEach((image) => {
        image.src = image.dataset.src
    })
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadImages, {once: true})
} else {
    loadImages()
}
